import { getLocaleNumberSymbol, NumberSymbol } from "@angular/common";
import { AfterViewInit, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { NumberUtils } from 'src/app/common/utils/number.utils';

@Component({
  standalone: false,
    selector: "wfm-time-or-decimal-cell",
    template: `<input class="numeric-editor" #input type="text" (input)="onInput($event)" [(ngModel)]="value" style="width: 100%" autofocus (load)="onLoaded($event)">`,
    styleUrls: ["../numeric/numeric-editor.component.scss"]
})
export class TimeOrDecimalEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public params: any;
  public value: string;
  public previousVal: any;
  public locale: string;
  private cancelBeforeStart = false;
  private cellmetadata: any;
  public allowedChars: string = "";
  public decimalSeparator: string = "";
  private groupSeparator: string = "";

  @ViewChild("input", {read: ViewContainerRef}) public input;

  agInit(params: any): void {
    this.previousVal = params.value;
    this.locale = params.locale;
    this.decimalSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);
    this.groupSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Group);
    this.allowedChars = "1234567890:" + this.decimalSeparator;
    this.params = params;
    this.value = params.value || '';
    // AG Grid v31 renamed charPress to eventKey, but eventKey is also set for action keys
    // like "Enter" and "F2". Treat only single-character values as typed characters.
    const charPress = params.eventKey && params.eventKey.length === 1 ? params.eventKey : null;
    const isAllowed = charPress && (this.allowedChars.indexOf(charPress) >= 0);
    if (isAllowed) {
      this.params.value = charPress;
      this.value = this.params.value;
    }

    this.cancelBeforeStart = params.context.isLoading();
    if (this.params.column && this.params.column.colDef) {
      const field = this.params.column.colDef.field;
      if (this.params.metadata.cellmetadata) {
        this.cellmetadata = this.params.metadata.cellmetadata[field];
      } else {
        this.cellmetadata = {};
      }
    }

  }

  getValue(): any {
    // If value is in time format, return as is
    if (this.isTimeFormat(this.value)) {
      return this.value;
    }
    // If value is a valid decimal, convert to time format
    if (this.isValidDecimal(this.value)) {
      return NumberUtils.decimalToTime(this.value);
    }
    // Otherwise, return the value as is
    return this.value;
  }

  setValue(newValue: any) {
    this.value = newValue;
  }

  isCancelBeforeStart(): boolean {
    return this.cancelBeforeStart;
  }

  isCancelAfterEnd(): boolean {

    return false;

    // Validate value: must be decimal or hh:mm
    // const isValid = !this.decimalOrTimeValidator(this.value);
    // if (!isValid && this.params.context.showMessage) {
    //   this.params.context.showMessage('Invalid Input', 'Please enter a decimal or hh:mm value.', 'error');
    // }
    // return !isValid;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.input && this.input.element && this.input.element.nativeElement)
        this.input.element.nativeElement.focus();
    }, 0);
  }

  onInput(event: Event) {
    const input = (event.target as HTMLInputElement);
    // Only allow digits, colon, and decimal separator, but only one of each ':' and decimal
    const allowed = '0123456789:' + this.decimalSeparator;
    let filtered = '';
    let hasColon = false;
    let hasDecimal = false;
    for (const char of input.value) {
      if (!allowed.includes(char)) continue;
      if (char === ':') {
        if (hasColon || hasDecimal) continue; // Don't allow colon if decimal already present
        hasColon = true;
      }
      if (char === this.decimalSeparator) {
        if (hasDecimal || hasColon) continue; // Don't allow decimal if colon already present
        hasDecimal = true;
      }
      filtered += char;
    }
    input.value = filtered;
    this.value = filtered;
  }

  onLoaded($event: Event) {
    console.log('onLoaded', $event);
  }

  isTimeFormat(val: string): boolean {
    // Accepts any integer hours and two-digit minutes
    return /^\d+:\d{2}$/.test(val);
  }

  isValidDecimal(val: string): boolean {
    if (typeof val !== 'string') {
      return false;
    }
    // Accepts decimal numbers
    return /^\d+(\.\d+)?$/.test(val.replace(this.decimalSeparator, '.'));
  }

  // decimalToTime(val: string): string {
  //   // Deprecated: use NumberUtils.decimalToTime instead
  //   return NumberUtils.decimalToTime(val);
  // }
  //
  // timeToDecimal(val: string): string {
  //   // Converts hh:mm to decimal hours as string using NumberUtils
  //   return NumberUtils.timeToDecimal(val);
  // }

  decimalOrTimeValidator(value: string) {
    const decimalPattern = /^[0-9]+(\.[0-9]+)?$/;
    const timePattern = /^\d+:([0-5][0-9])$/;
    if (!value) return null;
    if (decimalPattern.test(value) || timePattern.test(value)) {
      return null;
    }
    return { invalidFormat: true };
  }
}
